import { takeLatest, put } from 'redux-saga/effects';
import moment from 'moment';

import { storage } from '@commons';

import {
  baixarManualEstoqueProducao,
  CONFIG_SESSION,
  NEW_BAIXAR_MANUAL_ESTOQUE_PRODUCAO,
  NEW_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_SUCCESS,
} from '@handler';

function* sagaNewBaixaManualEstoqueProducao(action) {

  yield put({ type: NEW_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_SUCCESS, registro: 
    {
      ...baixarManualEstoqueProducao.newRegistro,
      data: moment().startOf('day').format('YYYY-MM-DD'),
      cultura: JSON.parse(storage.get(CONFIG_SESSION)).safraAtiva.cultura,
    } });
}

export default function* watchNewBaixaManualEstoqueProducao() {
  yield takeLatest(NEW_BAIXAR_MANUAL_ESTOQUE_PRODUCAO, sagaNewBaixaManualEstoqueProducao)
}
